export default __webpack_public_path__ + "static/media/GoblinBody.4f9fb7f0.png";